import { bool, node } from "prop-types";

import styled from "styled-components/macro";

import FnrTypography from "UI/FnrTypography";

/**
 * The verification chip family's label typography — uppercase accent text, one
 * step below the field-name size (`xs`, not `sm`) so the chips read smaller.
 * Single source of truth for all three permutations (USPS Verified / Unverified
 * / Admin Verified) across the static and interactive chips, so the family can't
 * drift apart.
 *
 * `noGap`: drop the icon→label gap-tightening margin for an icon-less chip (the
 * unverified pill) — with no icon there's no trailing slack to overlap into, and
 * the negative margin would pull the label off-center.
 */
export default function ChipLabel({ children, noGap = false }) {
  return (
    <Label
      type="accent"
      fontSize="xs"
      bold={false}
      color="textSecondaryDark"
      $noGap={noGap}
    >
      {children}
    </Label>
  );
}

ChipLabel.propTypes = { children: node, noGap: bool };

// The icon's fixed-width container's trailing slack IS the icon→label gap, so a constant
// negative margin tightens the gap by overlapping that slack. The container stays fixed-width
// (so the label never shifts when the interactive badge morphs icons), and only the trailing
// slack is consumed — the leading slack is still the chip's left inset.
const Label = styled(FnrTypography)`
  text-transform: uppercase;
  margin-left: ${({ $noGap }) => ($noGap ? "0" : "-2px")};
`;
